export const translations = {
  en: {
    'Hello world': 'Testing translations II - The revenge',
  },
  options: {
    plural_rule: 'n != 1',
    plural_number: '2',
  },
}
